<template>
  <div id="last" class="last view start-gradient" :class="{ loading: loading }">
    <div class="next" @click="redoQuiz">
      <i class="fa fa-angle-left" aria-hidden="true"></i>
      Gör om testet
    </div>
    <div class="main-container">
      <div class="heart-back"></div>
      <div class="heart-loader-container" :class="{ loading: loading, loaded: loaded }">
        <div class="heart-loader"></div>
      </div>
      <div class="content-container">
        <h4>Det kan vara svårt att skilja på kärlek och kontroll</h4>
        <p>Alla som lever i en nära relation behöver då och då fundera över hur man är som partner. Om du känner dig orolig över om du är kontrollerande mot din partner - sök hjälp! Det går att förändra ett våldsamt beteende.</p>
        <p>Gå in på <a href="https://valjattsluta.se" target="_blank">valjattsluta.se</a></p>
        <p><b>Dela testet och hjälp oss att motverka våld i nära relationer. Dina svar kommer inte att synas.</b></p>
        <br>
      </div>
      <div class="social-icons">
        <a @click="shareFB"><i class="fa fa-facebook" aria-hidden="true"></i></a>
        <a @click="shareTwitter" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i></a>
        <a @click="shareLinkedIn"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LastView',
  data () {
    return {
      msg: 'Last',
      loading: true,
      loaded: false
    }
  },
  props: [],
  computed: {},
  methods: {
    shareFB () {
      window.FB.ui({
        method: 'share',
        href: 'https://allemanstestet.se'
      }, (response) => {})
    },
    shareTwitter () {
      window.open('https://twitter.com/intent/tweet?text=%C3%84r%20du%20nyfiken%20p%C3%A5%20hur%20du%20%C3%A4r%20som%20partner%3F%20G%C3%B6r%20Allemanstestet!&url=https://allemanstestet.se', '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600')
      return false
    },
    shareLinkedIn () {
      window.open('http://www.linkedin.com/shareArticle?mini=true&url=https://allemanstestet.se', '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=420,width=650')
    },
    redoQuiz () {
      this.$router.push('quiz')
    }
  },
  mounted () {
    window.setTimeout(() => {
      this.loading = false
    }, 4000)
    window.setTimeout(() => {
      this.loaded = true
    }, 100)
    window.gtag('event', 'finished', {
      'event_category': 'finished',
      'event_label': 'finished'
    })
  },
  components: {}
}
</script>

<style scoped>
.next {
  color: #fff;
  position: absolute;
  top: 3vh;
  left: 3.6vh;
  z-index: 999;
  font-size: 0.95em;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.2s ease-in;
}
.next:hover {
  left: 3.2vh;
}
.loading .next {
  display: none;
}
.last {
  color: #fff;
}
.main-container {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  width: 100%;
}
.heart-back {
  z-index: 1;
  height: 96vh;
  position: absolute;
  bottom: 0px;
  width: 100%;
  background-image: url('/static/heart_loading_empty.svg');
  background-size: 76% auto;
  background-repeat: no-repeat;
  background-position: center center;
}
.heart-loader {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 96vh;
  background-image: url('/static/img/heart_loading_full.svg');
  background-size: 76% auto;
  background-repeat: no-repeat;
  background-position: center center;
  opacity: 1;
  /* clip-path: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiP…IuNyIvPg0KCQkJCTwvZz4NCgkJCTwvZz4NCgkJPC9nPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K'); */
}
.heart-loader-container {
  display: none;
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 10vh;
  overflow: hidden;
  transition: all 3.5s ease-in;
}
.heart-loader-container.loading {
  display: block;
}
.heart-loader-container.loaded {
  height: 90vh;
  transition: all 3.5s ease-in;
}
.social-icons {
  position: absolute;
  bottom: 2vh;
  margin: auto;
  width: 100%;
  z-index: 100;
}
.social-icons a {
  background-color: #fff;
  color: #FD385A;
  height: 23vw;
  width: 23vw;
  cursor: pointer;
  vertical-align: middle;
  line-height: 23vw;
  border-radius: 23vw;
  margin: 2.2vw;
  display: inline-block;
  font-size: 9vw;
  position: relative;
  transition: all 0.15s ease-in;
}
.social-icons a:hover {
  transform: translateY(-4px);
}
.content-container {
  transition: all 0.6s ease-in;
  position: relative;
  z-index: 99;
}
.loading .content-container, .loading .social-icons {
  opacity: 0;
}
h4 {
  font-weight: bold;
  font-size: 1.3rem;
  line-height: 1.5rem;
  margin: auto;
  max-width: 90%;
}
p {
  margin: 4vh 4vh;
  font-size: 1rem;
  line-height: 1.3rem;
}
a {
  font-weight: bold;
  color: inherit;
  font-style: none;
  text-decoration: none;
}
.splashing .heart-back {
  background-size: 76% auto;
  background-repeat: no-repeat;
  background-position: center center;
}
.view {
  height: 100%;
  display: table;
  vertical-align: top;
  width: 100%;
}
@media screen and (min-width: 480px) {
  .content-container {
    max-width: 500px;
    margin: auto;
    position: relative;
  }
  .heart-back {
    background-image: url('../assets/img/heart_loading_empty.svg');
    background-size: 30vh;
  }
  .loading .heart-back {
    background-image: url('../assets/img/heart_loading_empty.svg');
    background-size: 30vh;
  }
  .heart-loader {
    background-size: 30vh;
  }
  h4 {
    font-size: 1.8rem;
    line-height: 2rem;
  }
  p {
    margin: 5vh;
  }
  p b {
  }
  p:first-child {
    margin-top: 9vh;
  }
  .social-icons {
    position: relative;
    display: block;
    margin: auto;
    width: 100%;
    bottom: auto;
  }
  .social-icons a {
    background-color: #fff;

    color: #FD385A;
    height: 70px;
    width: 70px;
    vertical-align: middle;
    line-height: 70px;
    border-radius: 70px;
    margin: 10px;
    display: inline-block;
    font-size: 33px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LastView.vue